define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/CustomerServerGroupModel", "../../models/UserContext"], function (require, exports, $, ko, log, tools, CustomerServerGroupModel, UserContext) {
    "use strict";
    var CustomerServersActions = /** @class */ (function () {
        function CustomerServersActions() {
            this.editDomainModel = ko.observable(new CustomerServerGroupModel());
            this.userCanUpdateDns = ko.observable(UserContext.hasAccess("Admin,Dns.Edit,Dns.Delete"));
            this.userCanDeleteDns = ko.observable(UserContext.hasAccess("Admin,Dns.Delete"));
            this.deleteDns = ko.observable(false);
            this.dnsInfo = ko.observable();
            this.dnsInfoText = ko.observable("");
            this.canUpdateDns = false;
        }
        CustomerServersActions.prototype.init = function () {
        };
        CustomerServersActions.prototype.editCustomerDomain = function (customerId, id, customerName) {
            var self = this;
            self.editDomainModel(new CustomerServerGroupModel());
            self.dnsInfo = ko.observable();
            var title = $.isNumeric(id) ? "Edit Customer Domain" : "Add Customer Domain";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    var selectedServer = self.serversDropDownList.dataItem();
                    if (selectedServer) {
                        self.editDomainModel().ServerId(selectedServer.Id);
                    }
                    else {
                        self.editDomainModel().ServerId(null);
                    }
                    if (self.editDomainModel().DnsName()) {
                        self.editDomainModel().DnsName(self.editDomainModel().DnsName().toLowerCase());
                        self.editDomainModel().Dns(self.editDomainModel().DnsName().toLowerCase() + "." + self.editDomainModel().DnsDomain().toLowerCase());
                    }
                    if (!self.editDomainModel().ServerId()) {
                        tools.error("Server is a required field");
                        return;
                    }
                    if (!self.editDomainModel().DnsName()) {
                        tools.error("Domain Name is a required field");
                        return;
                    }
                    if (self.dnsInfo().DnsProvider === 'DynDns') {
                        if (!self.editDomainModel().IpAddress()) {
                            tools.error("IP Address is a required field");
                            return;
                        }
                        if (!self.editDomainModel().UserPassword()) {
                            tools.error("User Password is a required field");
                            return;
                        }
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerDomain(event.currentTarget, modal);
                },
                opened: function (modal) {
                    self.dnsInfoText("");
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerServers/GetServerGroupById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editDomainModel(new CustomerServerGroupModel(result.Data));
                                    self.editDomainModel().DnsDomain.subscribe(function () {
                                        self.checkDomainName();
                                    });
                                    self.editDomainModel().DnsName.extend({ rateLimit: { timeout: 300, method: "notifyWhenChangesStop" } });
                                    self.editDomainModel().DnsName.subscribe(function () {
                                        self.checkDomainName();
                                    });
                                    self.editDomainModel().UpdateDns.subscribe(function () {
                                        self.checkDomainName();
                                    });
                                }
                            }
                        });
                    }
                    else {
                        self.editDomainModel(new CustomerServerGroupModel());
                        self.editDomainModel().CustomerId(customerId);
                        self.editDomainModel().CustomerName(customerName);
                        self.editDomainModel().DnsDomain("tgpbx.com");
                        self.editDomainModel().DnsDomain.subscribe(function () {
                            self.checkDomainName();
                        });
                        self.editDomainModel().DnsName.extend({ rateLimit: { timeout: 300, method: "notifyWhenChangesStop" } });
                        self.editDomainModel().DnsName.subscribe(function () {
                            self.checkDomainName();
                        });
                        self.editDomainModel().UpdateDns.subscribe(function () {
                            self.checkDomainName();
                        });
                    }
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/OfficeLocations/GetLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    var getDnsCall = null;
                    if (!id) {
                        getDnsCall = self.checkDomainName();
                    }
                    $.when(getModelCall, getLookupData, getDnsCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'server-group-assign-template', data: editDomainModel }\"></div>");
                        ko.applyBindings(self, modal);
                        $(".dropdown-menu li", modal).click(function (e) {
                            var selected = $(this).data("domain");
                            self.editDomainModel().DnsDomain(selected);
                            e.preventDefault();
                        });
                        self.serversDropDownList = $("#ServerId", modal).kendoComboBox({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select server...",
                            dataTextField: "IpAddress",
                            dataValueField: "Id",
                            dataSource: {
                                transport: {
                                    read: {
                                        url: "/Servers/GetServersLookup",
                                        type: "POST",
                                        dataType: "json"
                                    }
                                },
                                schema: {
                                    data: function (response) { return response.Data; },
                                    total: "Total"
                                },
                                serverFiltering: true
                            },
                            dataBound: function () {
                            },
                            cascade: function (e) {
                                if (self.serversDropDownList.dataItem()) {
                                    self.dnsInfo(self.serversDropDownList.dataItem().DnsInfo);
                                    self.editDomainModel().ServerId(self.serversDropDownList.dataItem().Id);
                                    self.editDomainModel().DnsDomain(self.dnsInfo().DnsZoneName);
                                }
                                else {
                                    if (self.editDomainModel().ServerId()) {
                                        self.dnsInfo(undefined);
                                        self.editDomainModel().ServerId(null);
                                        self.editDomainModel().DnsDomain(undefined);
                                    }
                                }
                            }
                        }).data("kendoComboBox");
                        self.serversDropDownList.wrapper.width("100%");
                        self.serversDropDownList.value(self.editDomainModel().ServerId());
                        self.editDomainModel().UpdateDns.subscribe(function () {
                            self.serversDropDownList.enable(self.editDomainModel().UpdateDns());
                        });
                        self.serversDropDownList.enable(self.editDomainModel().UpdateDns());
                        $(function () {
                            $('[data-toggle="tooltip"]', modal).tooltip();
                        });
                    });
                }
            });
        };
        CustomerServersActions.prototype.checkDomainName = function () {
            var self = this;
            if (self.checkDomainRequest && self.checkDomainRequest.readyState !== 4) {
                self.checkDomainRequest.abort();
                log.log("request aborted");
            }
            $("#dnsDomainHolder").removeClass("has-warning").removeClass("has-success").removeClass("has-error");
            self.dnsInfoText("");
            if (!self.editDomainModel().UpdateDns()) {
                return null;
            }
            $("#dnsCheckLoader").show();
            var request = tools.ajaxGet({
                url: "/CustomerLocations/CheckDomainNameJson",
                data: {
                    CustomerId: self.editDomainModel().CustomerId(),
                    // customerName: self.editDomainModel().CustomerName(),
                    domainName: self.editDomainModel().DnsDomain(),
                    dnsName: self.editDomainModel().DnsName() ? self.editDomainModel().DnsName().toLowerCase() : "",
                    serverId: self.editDomainModel().Id(),
                    useAccountNumber: true
                },
                success: function (result) {
                    if (result.Success) {
                        log.log(result.Data);
                        $("#dnsDomainHolder").removeClass("has-warning").removeClass("has-success").removeClass("has-error");
                        self.dnsInfoText("");
                        if (!self.editDomainModel().DnsName() && result.Data.suggestedDnsName) {
                            self.editDomainModel().DnsName(result.Data.suggestedDnsName.toLowerCase());
                        }
                        if (result.Data.currentDnsValid && result.Data.suggestedDnsNameIpAddress) {
                            $("#dnsDomainHolder").addClass("has-warning");
                            self.canUpdateDns = true;
                            self.dnsInfoText("Subdomain is available to create in BO system but subdomain already has assigned IP address ("
                                + result.Data.suggestedDnsNameIpAddress
                                + ")."
                                + (result.Data.moreInfo.DnsDetails ? "<br/><strong>" + result.Data.moreInfo.DnsDetails + "</strong><br/>" : "")
                                + "Subdomain will be updated if server and DNS info are provided");
                        }
                        else if (result.Data.currentDnsValid && !result.Data.suggestedDnsNameIpAddress) {
                            $("#dnsDomainHolder").addClass("has-success");
                            self.canUpdateDns = true;
                            self.dnsInfoText("Subdomain is available to create");
                        }
                        else {
                            $("#dnsDomainHolder").addClass("has-error");
                            self.canUpdateDns = false;
                            self.dnsInfoText("Subdomain is in use."
                                + (result.Data.currentMoreInfo.DnsDetails ? "<br/><strong>" + result.Data.currentMoreInfo.DnsDetails + "</strong><br/>" : "")
                                + " Suggested name to use: " + result.Data.suggestedDnsName);
                        }
                    } /*else {
                        log.error(result.Error);
                    }*/
                }
            });
            request.always(function () {
                $("#dnsCheckLoader").hide();
            });
            self.checkDomainRequest = request;
            return request;
        };
        CustomerServersActions.prototype.saveCustomerDomain = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editDomainModel);
            obj["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerServers/SaveServerGroup",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.saveCallback) {
                        self.saveCallback();
                    }
                    $(modal).modal("hide");
                    return;
                } /*else {
                    tools.error(result.Error);
                }*/
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerServersActions.prototype.deleteServerGroupConfirm = function (group) {
            var self = this;
            self.deleteDns(false);
            tools.editModal({
                title: "Delete Customer Domain",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteServerGroup(group.Id, self.deleteDns());
                    $(event.currentTarget).button("reset");
                    $(modal).modal("hide");
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customerservergroup-remove-template', data: $root }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        CustomerServersActions.prototype.deleteServerGroup = function (groupId, deleteDns) {
            var self = this;
            var data = {
                id: groupId,
                deleteDns: deleteDns
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerServers/DeleteServerGroupConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Customer Domain deleted successfully");
                    if (self.deleteCallback) {
                        self.deleteCallback();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerServersActions.prototype.loginToServer = function (ipAddress, domain) {
            var self = this;
            tools.ajaxGet({
                url: "/CustomerServers/GetLoginToken?ipAddress=".concat(ipAddress, "&domain=").concat(domain)
            }).done(function (result) {
                if (result.Success) {
                    log.log("impersonate success");
                    setTimeout(function () {
                        var serverDomain = result.Data.serverDomain;
                        var tempSessionId = result.Data.sessionId;
                        var url = "https://".concat(serverDomain, "/thirdparty.htm");
                        tools.ajaxPost({
                            url: "https://".concat(serverDomain, "/rest/system/session"),
                            data: JSON.stringify({
                                name: "session",
                                value: tempSessionId
                            }),
                            xhrFields: {
                                withCredentials: true
                            }
                        }).done(function (result) {
                            log.log("temp session applied: " + result);
                            if (result) {
                                self.loginToServerLink(url);
                            }
                            else {
                                tools.error("Unable to login to PBX server");
                            }
                        });
                    });
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerServersActions.prototype.loginToServerLink = function (url) {
            var self = this;
            tools.alertModal({
                title: "Login To Server",
                html: "<a class=\"btn btn-info\" href=\"".concat(url, "\" target=\"_blank\">Log in to Server</a>"),
                buttonTitle: "Close",
                type: "info",
                modalOptions: {},
                open: function (modal) {
                    $('a', modal).on("click", function () {
                        $(modal).modal("hide");
                    });
                }
            });
        };
        CustomerServersActions.prototype.showExtensionInfo = function (info) {
            var self = this;
            tools.alertModal({
                title: "Extension info",
                html: info,
                buttonTitle: "Close",
                type: "info",
                modalOptions: {},
                open: function (modal) {
                    $('a', modal).on("click", function () {
                        $(modal).modal("hide");
                    });
                }
            });
        };
        return CustomerServersActions;
    }());
    return CustomerServersActions;
});
//# sourceMappingURL=customerServersActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerServersActions.js
// module id = 160
// module chunks = 2